// extracted by mini-css-extract-plugin
export default {"container":"services-module--container--3KT7G"};